module.exports = __webpack_public_path__ + "img/icon_kefu_black-1.ab57fbf6.png";